import { useEffect, useState } from "react";
import axios from "axios";
import "./history.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Danh sách các sảnh cơ bản để bộ lọc (Bạn có thể thêm bớt tùy ý)
const sanhOptions = [
    { id: "all", name: "Tất cả sảnh" },
    { id: "RNG", name: "Game Nổ Hũ (RNG)" },
    { id: "LIVE", name: "Casino (LIVE)" },
    { id: "SPORTS", name: "Thể Thao (SPORTS)" },
    { id: "PVP", name: "Game Bài (PVP)" }
];

function HistoryCasino() {
    function formatDate(m) {
        if (!m) return "";
        var dateObj = new Date(m);
        dateObj.setHours(dateObj.getHours() - 1);
        const dateString =
            dateObj.getUTCFullYear() +
            "/" +
            ("0" + (dateObj.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + dateObj.getDate()).slice(-2) +
            "  " +
            ("0" + dateObj.getHours()).slice(-2) +
            ":" +
            ("0" + dateObj.getMinutes()).slice(-2);
        return dateString;
    }

    const [history, setHistory] = useState([]);
    const [isLoading, setLoading] = useState(false);
    
    // Các State phục vụ Bộ Lọc và Phân trang
    const [endDate, setEndDate] = useState(new Date());
    const [selectedSanh, setSelectedSanh] = useState("all");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limitPerPage = 30; // Chốt 30 dữ liệu / 1 trang

    // Hàm gọi API bốc dữ liệu
    const fetchHistoryData = () => {
        setLoading(true);
        const year = endDate.getFullYear();
        const month = String(endDate.getMonth() + 1).padStart(2, "0");
        const day = String(endDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`; 

        // Payload gửi xuống Backend
        const payload = {
            date: formattedDate,
            limit: limitPerPage,
            page: page
        };

        // Nếu người dùng chọn 1 sảnh cụ thể thì mới gửi kèm điều kiện sanh
        if (selectedSanh !== "all") {
            payload.sanh = selectedSanh;
        }

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/history-db`, payload)
            .then((res) => {
                // Hứng dữ liệu mảng
                const records = res.data?.data?.data || res.data?.data || [];
                setHistory(records);

                // Tính toán tổng số trang dựa vào total records Backend trả về
                const totalRecords = res.data?.data?.total || 0;
                setTotalPages(Math.ceil(totalRecords / limitPerPage) || 1);
            })
            .catch((err) => {
                console.error("Lỗi lấy lịch sử:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // useEffect sẽ TỰ ĐỘNG CHẠY lại hàm fetchHistoryData mỗi khi 1 trong 3 biến (endDate, page, selectedSanh) thay đổi
    useEffect(() => {
        fetchHistoryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endDate, page, selectedSanh]);

    // Xử lý khi người dùng đổi ngày
    const handleDateChange = (date) => {
        setPage(1); // Trở về trang 1
        setEndDate(date);
    };

    // Xử lý khi người dùng chọn Sảnh khác
    const handleSanhChange = (e) => {
        setPage(1); // Trở về trang 1
        setSelectedSanh(e.target.value);
    };

    // Xử lý chuyển trang
    const handleNextPage = () => {
        if (page < totalPages) setPage(page + 1);
    };
    const handlePrevPage = () => {
        if (page > 1) setPage(page - 1);
    };

    const productId = (data) => {
        if (!data) return "";
        let a;
        switch (data.toString()) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "98": a = "PG"; break;
            case "99": a = "TF"; break;
            case "3": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            case "61": a = "IMES"; break;
            case "132": a = "SV388"; break;
            default: a = ""; break;
        }
        return a;
    };

    return (
        <>
            {isLoading ? (
                <div className="loading" style={{ maxWidth: "100%" }}>
                    <div className="loader"></div>
                </div>
            ) : null}
            <div className="historyrecharge">
                <div className="top_title">
                    <div className="txt">Lịch sử sảnh game</div>
                </div>
                
                {/* THANH CÔNG CỤ: CHỌN NGÀY VÀ CHỌN SẢNH */}
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", margin: "15px 0", flexWrap: "wrap" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>Ngày:</span>
                        <DatePicker
                            maxDate={new Date()}
                            selected={endDate}
                            onChange={handleDateChange}
                            className="date-picker-custom"
                        />
                    </div>
                    
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>Sảnh:</span>
                        <select 
                            value={selectedSanh} 
                            onChange={handleSanhChange}
                            style={{ padding: "6px 12px", borderRadius: "5px", border: "1px solid #ccc", outline: "none", cursor: "pointer", fontSize: "14px" }}
                        >
                            {sanhOptions.map(option => (
                                <option key={option.id} value={option.id}>{option.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {history && history.length > 0 ? (
                    <div className="main-history">
                        <div className="header-history">
                            <div style={{ width: "10%" }}>Sảnh</div>
                            <div style={{ width: "10%" }}>Loại</div>
                            <div style={{ width: "20%" }}>Tên trò chơi</div>
                            <div style={{ width: "10%" }}>Số tiền cược</div>
                            <div style={{ width: "10%" }}>Số tiền thắng</div>
                            <div style={{ width: "20%" }}>Mã giao dịch</div>
                            <div style={{ width: "20%" }}>Thời gian</div>
                        </div>
                        {history.map((item, key) => (
                            <div className="content-history" key={key}>
                                <div style={{ width: "10%" }}>{productId(item?.productType) || item?.sanh}</div>
                                <div style={{ width: "10%" }}>{item?.gameCategory || item?.sanh}</div>
                                <div style={{ width: "20%" }}>{item?.gameName}</div>
                                <div style={{ width: "10%" }}>{item?.betAmount?.toLocaleString("vi-VN")}</div>
                                <div style={{ width: "10%" }}>
                                    {item?.winAmount ? item.winAmount.toLocaleString("vi-VN") : item?.netPnl?.toLocaleString("vi-VN")}
                                </div>
                                <div style={{ width: "20%" }}>{item?.betOrderNo || item?.transactionId}</div>
                                <div style={{ width: "20%" }}>{formatDate(item?.betTime || item?.createdAt)}</div>
                            </div>
                        ))}

                        {/* THANH ĐIỀU HƯỚNG PHÂN TRANG (PAGINATION) */}
                        {totalPages > 1 && (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", marginTop: "20px", padding: "10px 0" }}>
                                <button 
                                    onClick={handlePrevPage} 
                                    disabled={page === 1}
                                    style={{ padding: "8px 16px", borderRadius: "4px", border: "none", backgroundColor: page === 1 ? "#ccc" : "#1B84FF", color: "#fff", cursor: page === 1 ? "not-allowed" : "pointer" }}
                                >
                                    Trang trước
                                </button>
                                
                                <span style={{ fontWeight: "bold" }}>
                                    Trang {page} / {totalPages}
                                </span>
                                
                                <button 
                                    onClick={handleNextPage} 
                                    disabled={page === totalPages}
                                    style={{ padding: "8px 16px", borderRadius: "4px", border: "none", backgroundColor: page === totalPages ? "#ccc" : "#1B84FF", color: "#fff", cursor: page === totalPages ? "not-allowed" : "pointer" }}
                                >
                                    Trang sau
                                </button>
                            </div>
                        )}

                    </div>
                ) : (
                    <div style={{ textAlign: "center", padding: "20px", color: "gray" }}>
                        {isLoading ? "Đang tải dữ liệu..." : "Không có lịch sử cược nào."}
                    </div>
                )}
            </div>
        </>
    );
}

export default HistoryCasino;